import React, { useState } from 'react';

import PropTypes from 'prop-types';
import {
  Button, Collapse, Link, Menu, MenuItem,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CollapseIconSVGR from '../../assets/svgr/CollapseIconSVGR';
import './styles.scss';

const CollapsedMenu = ({ items }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSubLinks, setOpenSubLinks] = useState(false);

  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const handleClose = (link) => {
    if (link.subLinks?.length > 0) {
      setOpenSubLinks(!openSubLinks);
    } else {
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Button
        variant='outlined'
        className='expand-header-button'
        onClick={handleClick}
      >
        <CollapseIconSVGR />
      </Button>
      <Menu
        className='responsive-menu'
        anchorEl={anchorEl}
        PaperProps={{
          className: 'responsive-menu-container',
        }}
        anchorOrigin={{
          vertical: 'bottom',
        }}
        transformOrigin={{
          vertical: 'top',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items.map((link) => (
          <>
            <MenuItem component={Link} href={link.subLinks?.length > 0 ? '#' : link.url} key={link.name} onClick={() => handleClose(link)}>
              {link.name.map((name) => (`${name} `))}
              {
                link.subLinks?.length > 0
              && <ArrowDropDownIcon />
              }
            </MenuItem>
            <Collapse in={openSubLinks} timeout='auto' unmountOnExit>
              <div className='header-sub-link'>
                {
                  link.subLinks?.map(({ name, url }) => (
                    <a href={url} className='header-sub-link' key={url}>
                      {name.map((text) => (<p key={text}>{text}</p>))}
                    </a>
                  ))
                }
              </div>
            </Collapse>

          </>
        ))}
      </Menu>
    </>
  );
};

CollapsedMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
};

CollapsedMenu.defaultProps = {
  items: undefined,
};

export default CollapsedMenu;
